module.exports = __webpack_public_path__ + "static/media/feature-tile-icon-06c.08e9e0a4.svg";